// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.discord-invite-card {
  background: #2b2d31;
  border-radius: 8px;
  padding: 14px 16px;
  margin: 8px 0;
  max-width: 440px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;
  user-select: none;
}

.discord-invite-card:hover {
  background: #313338;
  border-color: rgba(255, 255, 255, 0.15);
}

.invite-card-header-label {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.05em;
  color: #949ba4;
  margin-bottom: 10px;
  text-transform: uppercase;
}

.invite-card-body {
  display: flex;
  align-items: center;
  gap: 12px;
}

.invite-card-icon {
  width: 50px;
  height: 50px;
  min-width: 50px;
  border-radius: 14px;
  background: #1e1f22;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.invite-card-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.invite-card-icon.placeholder {
  color: #949ba4;
  background: rgba(255, 255, 255, 0.05);
}

.invite-card-letter {
  font-size: 20px;
  font-weight: 800;
  color: #f2f3f5;
}

.invite-card-details {
  flex: 1;
  min-width: 0;
}

.invite-card-title {
  font-size: 15px;
  font-weight: 700;
  color: #f2f3f5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 4px;
}

.invite-card-title.error-text {
  color: #f87171;
}

.invite-card-meta {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #949ba4;
  font-weight: 500;
}

.invite-card-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
  margin-right: 6px;
  box-shadow: 0 0 8px rgba(34, 197, 94, 0.4);
}

.invite-card-members {
  font-size: 12px;
  color: #949ba4;
}

.invite-card-action {
  margin-left: 8px;
}

.invite-card-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 18px;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}

.invite-card-btn.join {
  background: #248046;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(36, 128, 70, 0.35);
}

.invite-card-btn.join:hover {
  background: #1a6334;
  box-shadow: 0 4px 12px rgba(36, 128, 70, 0.45);
}

.invite-card-btn.joined {
  background: rgba(255, 255, 255, 0.08);
  color: #dbdee1;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.invite-card-btn.joined:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
}

/* Skeleton Loading */
.discord-invite-card.loading {
  display: flex;
  align-items: center;
  gap: 12px;
}

.invite-card-skeleton-avatar {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.06);
  animation: inviteSkeletonPulse 1.5s infinite ease-in-out;
}

.invite-card-skeleton-info {
  flex: 1;
}

.invite-card-skeleton-line {
  height: 12px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.06);
  margin-bottom: 6px;
  animation: inviteSkeletonPulse 1.5s infinite ease-in-out;
}

.invite-card-skeleton-line.short {
  width: 40%;
}

.invite-card-skeleton-line.title {
  width: 70%;
}

@keyframes inviteSkeletonPulse {
  0% { opacity: 0.5; }
  50% { opacity: 0.9; }
  100% { opacity: 0.5; }
}
`, "",{"version":3,"sources":["webpack://./src/components/MessageList/InviteCard.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,2CAA2C;EAC3C,yCAAyC;EACzC,gFAAgF;EAChF,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,wDAAwD;AAC1D;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,KAAK,YAAY,EAAE;EACnB,MAAM,YAAY,EAAE;EACpB,OAAO,YAAY,EAAE;AACvB","sourcesContent":[".discord-invite-card {\n  background: #2b2d31;\n  border-radius: 8px;\n  padding: 14px 16px;\n  margin: 8px 0;\n  max-width: 440px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);\n  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;\n  user-select: none;\n}\n\n.discord-invite-card:hover {\n  background: #313338;\n  border-color: rgba(255, 255, 255, 0.15);\n}\n\n.invite-card-header-label {\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  color: #949ba4;\n  margin-bottom: 10px;\n  text-transform: uppercase;\n}\n\n.invite-card-body {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.invite-card-icon {\n  width: 50px;\n  height: 50px;\n  min-width: 50px;\n  border-radius: 14px;\n  background: #1e1f22;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.invite-card-icon img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.invite-card-icon.placeholder {\n  color: #949ba4;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.invite-card-letter {\n  font-size: 20px;\n  font-weight: 800;\n  color: #f2f3f5;\n}\n\n.invite-card-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.invite-card-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #f2f3f5;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 4px;\n}\n\n.invite-card-title.error-text {\n  color: #f87171;\n}\n\n.invite-card-meta {\n  display: flex;\n  align-items: center;\n  font-size: 12px;\n  color: #949ba4;\n  font-weight: 500;\n}\n\n.invite-card-status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #22c55e;\n  margin-right: 6px;\n  box-shadow: 0 0 8px rgba(34, 197, 94, 0.4);\n}\n\n.invite-card-members {\n  font-size: 12px;\n  color: #949ba4;\n}\n\n.invite-card-action {\n  margin-left: 8px;\n}\n\n.invite-card-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 18px;\n  border-radius: 5px;\n  font-size: 13px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  white-space: nowrap;\n}\n\n.invite-card-btn.join {\n  background: #248046;\n  color: #ffffff;\n  box-shadow: 0 2px 8px rgba(36, 128, 70, 0.35);\n}\n\n.invite-card-btn.join:hover {\n  background: #1a6334;\n  box-shadow: 0 4px 12px rgba(36, 128, 70, 0.45);\n}\n\n.invite-card-btn.joined {\n  background: rgba(255, 255, 255, 0.08);\n  color: #dbdee1;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.invite-card-btn.joined:hover {\n  background: rgba(255, 255, 255, 0.15);\n  color: #ffffff;\n}\n\n/* Skeleton Loading */\n.discord-invite-card.loading {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.invite-card-skeleton-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.06);\n  animation: inviteSkeletonPulse 1.5s infinite ease-in-out;\n}\n\n.invite-card-skeleton-info {\n  flex: 1;\n}\n\n.invite-card-skeleton-line {\n  height: 12px;\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.06);\n  margin-bottom: 6px;\n  animation: inviteSkeletonPulse 1.5s infinite ease-in-out;\n}\n\n.invite-card-skeleton-line.short {\n  width: 40%;\n}\n\n.invite-card-skeleton-line.title {\n  width: 70%;\n}\n\n@keyframes inviteSkeletonPulse {\n  0% { opacity: 0.5; }\n  50% { opacity: 0.9; }\n  100% { opacity: 0.5; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
